export const MARITAL_STATUS_FREE = 'ledig';
export const MARITAL_STATUS_MARRIED = 'verheiratet';
export const MARITAL_STATUS_DIVORCED = 'geschieden';

export const MARITAL_STATUS_SELECT = [
  {_id: MARITAL_STATUS_FREE, name: MARITAL_STATUS_FREE},
  {_id: MARITAL_STATUS_MARRIED, name: MARITAL_STATUS_MARRIED},
  {_id: MARITAL_STATUS_DIVORCED, name: MARITAL_STATUS_DIVORCED},
];
export const ROLE_ADMIN = 'Admin';
export const ROLE_USER = 'User';
export const ROLE_THOMASHILFEN = 'Thomashilfen';

export const ROLE_SELECT = [
  {_id: ROLE_USER, name: ROLE_USER},
  {_id: ROLE_ADMIN, name: ROLE_ADMIN},
  {_id: ROLE_THOMASHILFEN, name: ROLE_THOMASHILFEN},
];

export const USER_STATUS_NEW = 'new';
export const USER_STATUS_ACTIVE = 'active';
export const USER_STATUS_INACTIVE = 'inactive';



// WEBPACK FOOTER //
// ./src/constants/userConstants.js